const yejiPage = () =>
  import('@/views/main/performance-commission/yeji/yeji.vue')
export default {
  path: '/main/yejiPage',
  name: ' yejiPage',
  component: yejiPage,
  children: []
}
